// File: components/EmptyStateCard.tsx
import { ButtonPrimary } from 'components/Button'
import CurrencyLogo from 'components/CurrencyLogo'
import React, { useContext } from 'react'
import { Text } from 'rebass'
import { ThemeContext } from 'styled-components'
import { ThemedText } from 'theme'

import { useRewards } from '../../context/RewardContext'
import { BlurBox, CurrencyFlexBetween, FlexRowCenter, InnerCardFlex, NoStakeCard } from '../../styleds'

const EmptyStateCard: React.FC = () => {
  const theme = useContext(ThemeContext)
  const { stakingType, rewardVaultRewardToken } = useRewards()

  const rewardVaultRewardSymbol = rewardVaultRewardToken?.symbol
  const tokenSymbol = stakingType === 'rewardVault' && rewardVaultRewardSymbol ? rewardVaultRewardSymbol : 'KDK'

  const buttonText =
    stakingType === 'rewardVault' && rewardVaultRewardSymbol ? `Claim ${rewardVaultRewardSymbol} Rewards` : 'Claim'

  return (
    <NoStakeCard>
      <BlurBox>
        <ThemedText.DeprecatedBody fontSize="20px" fontWeight="500" lineHeight="14px" color={theme.textPrimary}>
          Deposit and stake liquidity to earn extra rewards
        </ThemedText.DeprecatedBody>
      </BlurBox>

      <ThemedText.DeprecatedBody fontSize="14px" fontWeight="400" lineHeight="14px" color={theme.textPrimary}>
        Earned
      </ThemedText.DeprecatedBody>

      <InnerCardFlex>
        <CurrencyFlexBetween>
          <FlexRowCenter>
            <CurrencyLogo currency={undefined} size="20px" />
            <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
              {tokenSymbol}
            </ThemedText.DeprecatedBody>
          </FlexRowCenter>
          <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
            {0}
          </ThemedText.DeprecatedBody>
        </CurrencyFlexBetween>

        <ButtonPrimary disabled={true}>
          <Text fontSize={20} fontWeight={500}>
            {buttonText}
          </Text>
        </ButtonPrimary>
      </InnerCardFlex>
    </NoStakeCard>
  )
}

export default EmptyStateCard
